// extracted by mini-css-extract-plugin
export default {"root":"GuidingPrincipals_root__4PQ41","lastUpdated":"GuidingPrincipals_lastUpdated__b6WBh marketplaceBodyFontStyles"};